<template>
	<div
		:class="subcategory ? '' : 'ml-5 mt-5'"
		:style="subcategory ? '' : 'width: 95%'"
	>
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<b-modal
			id="productcategory-modal"
			ref="addproductcategory-modal"
			hide-footer
		>
			<template #modal-title>
				Create New Lister Item
			</template>
			<div class="d-block text-center">
				<b-form-group
					class="form-group"
					label="Name: "
					label-for="block-form1-name"
				>
					<b-form-input
						v-model="name"
						type="text"
						@keyup.enter="addProductCategory"
					/>
				</b-form-group>
			</div>
			<b-button
				class="mt-3"
				block
				@click="addProductCategory()"
			>
				Save
			</b-button>
		</b-modal>
		<b-row class="d-flex justify-content-end mb-4">
			<b-col
				sm="5"
				md="3"
				class="my-1"
				align-self="center"
			>
				<b-form-group
					label="Language:"
					label-for="search-group-select"
					label-cols-sm="6"
					label-cols-md="4"
					label-cols-lg="4"
					label-align-sm="right"
					label-size="sm"
					class="mb-0"
				>
					<custom-select
						v-model="language"
						:options="languageOptions"
						@change="translateTableData(language)"
					/>
				</b-form-group>
			</b-col>
		</b-row>
		<base-block
			:title="subcategory ? '' : 'Existing Lister Items'"
			header-bg
		>
			<div
				ref="productCategory"
			/>
		</base-block>
	</div>
</template>
